import React from "react";
import { connect } from "react-redux";
import { NavLink } from 'react-router-dom';
import { getGrupos, eliminarGrupo } from "../usuario/UsuarioService";
import "../../styles/Empresa.css";
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import TablaItemsConfiguracion from "../componentes/tablas/TablaItemsConfiguracion";
import ModalEliminarConDetalles from "../componentes/modales/ModalEliminarConDetalles.js";
import PantallaCarga from "../mensajeFlash/PantallaCarga.js";
import ModalDetalleConfiguraciones from "../componentes/modales/ModalDetalleConfiguraciones.js";
import { verificarRol, gestionLegajos } from "../../constans/constants";


class GruposUsuarios extends React.Component {
  constructor(props) {
    super(props);

    const { location } = this.props;
    const estado = location && location.state ? location.state : {};

    this.state = {
      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      open: false,
      mensajeFlash: estado.mensajeFlash || "",
      mostrarMensajeFlash: estado.mostrarMensajeFlash || false,
      mensajeFlashSeverity: estado.mensajeFlashSeverity || "neutral",

      gruposData: null
    };
    this.modalRef = React.createRef(); //referencia al modal
    this.tablaRef = React.createRef(); //referencia a la tabla de elementos
    this.modalEliminarRef = React.createRef();
  }

  handleClickOpen = (data = null) => {
    this.setState({
      open: true,
      gruposData: data
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleDialogVerDatos = (value, grupoSeleccionado = null) => {
    this.setState({ dialogIsOpenVerDatos: value }, () => {
      if (value && grupoSeleccionado && this.modalRef) {
        this.modalRef.current.cargarDetalles(grupoSeleccionado);
      }
    });
  };

  handleDisableGrupo = () => {
    this.modalEliminarRef.current.cerrarModalConAnimacion()
    this.setState({ openPantallaCarga: true })
    let selectedGruposUsuarios = this.state.gruposData
    this.props.eliminarGrupo(selectedGruposUsuarios.id).then((response) => {
      this.setState({
        openPantallaCarga: false,
        mostrarMensajeFlash: true,
        mensajeFlash: response.mensaje,
        mensajeFlashSeverity: response.error ? 'error' : 'exito'
      });
      this.actualizarDatosTabla()
    })
  }

  handleNewGrupo = () => {
     this.props.history.push('/administracion/grupos/add')
  };

  fetchGrupos = (page, pageSize, search) => {
    return this.props.getGrupos(page, pageSize, search).then(() => {
      const { gruposData } = this.props;
      return {
        items: gruposData.grupos,
        totalCount: gruposData.totalCount,
      };
    });
  }

  handleEditarUsuario = (datos) =>{
    this.props.history.push({
      pathname: '/administracion/grupos/edit',
      state:{
        datosGrupo: datos
      }
    })
  }

  renderFilas = (filas) => {
    return filas.map((f) => (
      <tr key={f.id}>
        <td>{f.descripcion}</td>
        <td>{f.activo ? 'Si' : 'No'}</td>
        <td>
          <div className="table-actions">
            <button className="table-icon open-dialog" data-dialog="modal-detalle-documento"
              data-id={f.id} onClick={() => this.handleDialogVerDatos(true, f)}>
              <span className="material-symbols-outlined"> visibility </span>
            </button>
            <button className="table-icon" onClick={() => this.handleEditarUsuario(f)}>
              <span className="material-symbols-outlined"> edit </span>
            </button>
            <button className="table-icon open-dialog" data-dialog="modal-delete-details" data-id={f.id}
              onClick={() => this.handleClickOpen(f)}>
              <span className="material-symbols-outlined"> delete </span>
            </button>
          </div>
        </td>
      </tr>
    ));
  }

  actualizarDatosTabla = () => {
    if (this.tablaRef) {
      this.tablaRef.fetchData();
    }
  }

  render() {
    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl={'/bandeja/pendientes'}
                breadcrumbs={
                  [
                    { label: 'Menu principal', path: '/bandeja/pendientes' }
                  ]
                }
              />

              <nav className="nav-area">
                <NavLink to="/administracion/usuarios" className="nav-link">
                  <span className="material-symbols-outlined"> account_circle </span> Usuarios
                </NavLink>
                <NavLink to="/administracion/grupos" className="nav-link">
                  <span className="material-symbols-outlined"> supervised_user_circle </span>  Grupos de usuarios
                </NavLink>
                {verificarRol(JSON.parse(localStorage.getItem("roles")), [gestionLegajos]) && <NavLink to="/administracion/legajos" className="nav-link">
                    <span className="material-symbols-outlined"> assignment_ind </span> Legajos
                </NavLink>}
                {verificarRol(JSON.parse(localStorage.getItem("roles")), [gestionLegajos]) && <NavLink to="/administracion/vacaciones" className="nav-link">
                  <span className="material-symbols-outlined">beach_access</span> Vacaciones
                </NavLink>}
              </nav>

              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title"> Gestión de grupos de usuarios </h1>
                  <p className="page-description"> Desde este menú puede gestionar los grupos de usuarios de su compañía</p>
                </div>
                <div className="head-actions">
                  <button onClick={() => this.handleNewGrupo()} className="btn-medium btn-primary"> <span className="material-symbols-outlined"> group_add </span> Nuevo Grupo </button>
                </div>
              </div>
            </div>
          </header>
          <div className="wrapperContent">
            <div className="page-container">
              <TablaItemsConfiguracion
                ref={(ref) => (this.tablaRef = ref)}
                titulo="Grupos de usuarios"
                headers={["Descripcion", "Activo", "Acciones"]}
                fetchDatos={this.fetchGrupos}
                renderFilas={this.renderFilas}
              />
            </div>
          </div>
          <ModalDetalleConfiguraciones
            ref={this.modalRef}
            abierto={this.state.dialogIsOpenVerDatos}
            onClose={() => this.handleDialogVerDatos(false)}
            titulo="Datos del grupo"
            renderContenido={(datos) => (
              <div className="card">
                <div className="card-content">
                  <div className="content-inner">
                    <span className="label"> Descripcion </span>
                    <span className="txt"> {datos.descripcion?.trim() || "--"}  </span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> Activo </span>
                    <span className="txt"> {datos.activo ? 'Sí' : 'No'} </span>
                  </div>
                </div>
                  <div className="content-inner">
                    <span className="label"> Miembros asociados ({datos.miembros?.length || 0}) </span>
                    {
                      datos.miembros == null || datos.miembros.length === 0
                        ? <span className="txt"> No hay miembros asociados a este grupo</span>
                        : (
                          <div className="responsive-table">
                            <table>
                              <thead>
                                <tr>
                                  <th>Nombre completo</th>
                                  <th>Usuario</th>
                                </tr>
                              </thead>
                              <tbody>
                                {datos.miembros.map((miembro) => (
                                  <tr key={miembro.id}>
                                    <td>{miembro.nombreApellido?.trim() || "--"}</td>
                                    <td>{miembro.usuario?.trim() || "--"}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )
                    }
                  </div>
              </div>
            )} />
        </div>
        <MensajeFlash
          visible={this.state.mostrarMensajeFlash}
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity} />

        <ModalEliminarConDetalles
          ref={this.modalEliminarRef}
          isOpen={this.state.open}
          cerrarModal={this.handleClose}
          onConfirmar={this.handleDisableGrupo}
          elemento={this.state.gruposData}
          titulo="usuario"
          detallesAMostrar={[
            { clave: 'descripcion', etiqueta: 'Descripción' }
          ]}
          mensaje="Esta acción eliminará el grupo seleccionado."
          textoBotonAccion="CONFIRMAR ELIMINACIÓN"
        />

        <PantallaCarga open={this.state.openPantallaCarga}/>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getGrupos: (page, size, search) => dispatch(getGrupos(page, size, search)),
  eliminarGrupo: (id) => dispatch(eliminarGrupo(id)),
});

const mapStateToProps = (state) => ({
  gruposData: state.gruposData,
});

export default connect(mapStateToProps, mapDispatchToProps)(GruposUsuarios);